import config from '../config';
import {
  customFetch,
  authHeader,
  jsonHeader,
  handleResponse,
  commonRequestOptions,
  subjects,
} from '../helpers';

const endpointPath = config.api.API_URL + '/user_group';

export const userGroupService = {
  getAll,
  getById,
  getByUserId,
  getFromAD,
  getOwnedItemsTotalCount,
  getOwnedItemsCount,
  getOwnedItems,
  getMemberCount,
  getMembers,
  create,
  update,
  checkDestroy,
  destroy,
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function getById(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/${id}`, requestOptions, signal)
    .then(handleResponse)
    .then(res => {
      subjects.currentUserGroup.next(res.user_groups[0] || { user_group_id: id });
      return res;
    });
}

function getByUserId(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/user/${id}`, requestOptions, signal).then(handleResponse);
}

function getFromAD(search, access_token, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify({ access_token: access_token }),
  };
  return customFetch(
    `${endpointPath}/search_ad/${search}`,
    requestOptions,
    signal,
    true,
    true
  ).then(handleResponse);
}

function getOwnedItemsTotalCount(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/owned_items_total_count`, requestOptions, signal).then(
    handleResponse
  );
}

function getOwnedItemsCount(userId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/owned_items_count/${userId}`, requestOptions, signal).then(
    handleResponse
  );
}

function getOwnedItems(userId, objectName, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/owned_items/${userId}/${objectName}`,
    requestOptions,
    signal
  ).then(handleResponse);
}

function getMemberCount(userGroupId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/${userGroupId}/member_count`, requestOptions, signal).then(
    handleResponse
  );
}

function getMembers(userGroupId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/${userGroupId}/members`, requestOptions, signal).then(
    handleResponse
  );
}

function create(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function update(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function checkDestroy(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/check_delete`, requestOptions, signal).then(handleResponse);
}

function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}
